export default "__VITE_ASSET__BWpAnzni__"